import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductOrderPaymentModal = _resolveComponent("ProductOrderPaymentModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      href: "#",
      class: "btn btn-lg btn-success",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.modalShown = true), ["prevent"]))
    }, " Kursteilnahme buchen "),
    _createVNode(_component_ProductOrderPaymentModal, {
      regionId: _ctx.product.region_id,
      product: _ctx.product,
      shown: _ctx.modalShown,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShown = false)),
      onOrderSuccess: _ctx.onOrderSuccess
    }, null, 8, ["regionId", "product", "shown", "onOrderSuccess"])
  ]))
}